// const BADGE_ID = 1470;
const TEST_BEACON_ID = 6569;
class TornelliUtil {
  getUserCode(user) {
    const url = 'http://172.16.32.13:3546/api/User';
    const nameArray = user.name.toLowerCase().split(' ');
    let params = {};
    let headers = {};
    return _get(url, params, headers).then(data => {
      return data.find(u => {
        const name = u.Nome.toLowerCase();
        const surname = u.Cognome.toLowerCase();
        for (let i = 0; i < nameArray.length; i++) {
          const element = nameArray[i];
          if (name.indexOf(element) === -1 && surname.indexOf(element) === -1) {
            return false;
          }
        }
        return true;
      }).Codice1;
    });
  }
  // access(beacon) {
  //   beacon = beacon || TEST_BEACON_ID;
  //   const url = `http://172.16.32.13:3546/api/Access?beacon=${beacon}&user=${BADGE_ID}`;
  //   let data = {};
  //   let headers = {};
  //   return _post(url, data, headers).then(data => {
  //     console.log(data);
  //   });
  // }
  access(beacon) {
    beacon = beacon || TEST_BEACON_ID;
    const url = `https://api.rds.it/v1/test/tornello?beacon=${beacon}`;
    let params = {};
    let headers = {};
    return _get(url, params, headers).then(data => {
      console.log(data);
      return data;
    });
  }
}

// function _post(url, data, headers) {
//   return new Promise((resolve, reject) => {
//     window.cordova.plugin.http.post(url, data, headers, function (response) {
//       console.log(response.status);
//       resolve(JSON.parse(response.data));
//     }, function (response) {
//       console.error(response.error);
//       reject(new Error(response.error));
//     });
//   });
// }

function _get(url, params, headers) {
  return new Promise((resolve, reject) => {
    window.cordova.plugin.http.get(url,
      params, headers, (response) => {
        console.log(response.status);
        resolve(JSON.parse(response.data));
      }, function (response) {
        console.error(response.error);
        reject(new Error(response.error));
      });
  });
}
export default new TornelliUtil();
